import { render, staticRenderFns } from "./PingJiLiuChengView.vue?vue&type=template&id=a52a82b4&scoped=true"
import script from "./PingJiLiuChengView.vue?vue&type=script&lang=js"
export * from "./PingJiLiuChengView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a82b4",
  null
  
)

export default component.exports